import { useQuery } from '@tanstack/react-query';
import { GET_API_ROUTE } from 'src/constants/api';
import { SerializedVaultSnapshot } from 'src/db/schema';
import { VAULT_REFETCH_INTERVAL } from '../consts';
import { vaultQueryKeys } from '../vaultQueryKeys';

export type VaultSnapshotEssentials = Pick<
	SerializedVaultSnapshot,
	| 'ts'
	| 'slot'
	| 'oraclePrice'
	| 'totalAccountBaseValue'
	| 'totalAccountQuoteValue'
	| 'netDeposits'
	| 'netQuoteDeposits'
	| 'totalShares'
>;

async function fetchVaultSnapshots(
	vaultPubkey: string
): Promise<VaultSnapshotEssentials[]> {
	const response = await fetch(
		`${GET_API_ROUTE('vault-snapshots')}?vault=${vaultPubkey}`
	);

	if (!response.ok) {
		throw new Error('Failed to fetch vault snapshots');
	}

	return response.json();
}

const EMPTY_SNAPSHOTS: VaultSnapshotEssentials[] = [];

export function useVaultSnapshotHistory(vaultPubkey?: string) {
	return useQuery({
		queryKey: vaultQueryKeys.vaultSnapshots(vaultPubkey),
		queryFn: () => fetchVaultSnapshots(vaultPubkey!),
		enabled: !!vaultPubkey,
		staleTime: VAULT_REFETCH_INTERVAL,
		refetchInterval: VAULT_REFETCH_INTERVAL,
		initialData: EMPTY_SNAPSHOTS,
		initialDataUpdatedAt: 0,
	});
}
